import { LoadingSpinner } from "./LoadingSpinner";

interface PageLoadingFallbackProps {
  pageName?: string;
}

/**
 * PageLoadingFallback - Loading state for lazy-loaded pages
 * Provides a consistent loading experience across all routes
 */
export function PageLoadingFallback({ pageName }: PageLoadingFallbackProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-4">
        <LoadingSpinner size="lg" />
        {pageName && (
          <p className="text-sm text-muted-foreground animate-pulse">
            Laddar {pageName}...
          </p>
        )}
      </div>
    </div>
  );
}
